import React from "react";
import { Input, InputProps } from "antd";
import { normalizeInternationalPhoneInput } from "../utils/international-phone.util";

export const InternationalPhoneInput: React.FC<InputProps> = ({
  onChange,
  placeholder = "+33612345678",
  ...rest
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const normalized = normalizeInternationalPhoneInput(event.target.value);
    event.target.value = normalized;
    onChange?.(event);
  };

  return (
    <Input
      {...rest}
      placeholder={placeholder}
      onChange={handleChange}
      inputMode="tel"
      autoComplete="tel"
      maxLength={16}
    />
  );
};
